import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRight18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M17.0608 8.99997L10.5305 2.46964L9.46985 3.5303L14.1895 8.24997L1.00012 8.24997L1.00012 9.74997L14.1895 9.74997L9.46985 14.4696L10.5305 15.5303L17.0608 8.99997Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowRight18.displayName = 'ArrowRight18';
export default ArrowRight18;
